import { type PriceChangeQuery } from './definitions'

export const LITHIUM_OVERVIEW_FACTBOX_QUERIES: { [key: string]: PriceChangeQuery } = {
  'Lithium-Carbonate-Global-Weighted-Average': {
    category: 'Lithium Carbonate',
    name: 'Global Weighted Average',
    type: 'priceType',
  },
  'Lithium-Carbonate-EXW-China': {
    category: 'Lithium Carbonate',
    name: 'EXW China',
    type: 'shippingRoute',
    grade: 'Battery',
  },
  'Lithium-Hydroxide-EXW-China': {
    category: 'Lithium Hydroxide',
    name: 'EXW China',
    type: 'shippingRoute',
  },
}
